import gql from 'graphql-tag';

export default gql`
fragment AdminDonationItem on AdminDonation {
    id
    name
    active_from
    active_to
    cms_url
    donation_total
    # first_donation
    # last_donation
}
`;

// TODO: Put first_donation and last_donation into response when backend fix is in



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/AdminDonationItem.ts